export const constructImageSharpUrl = (baseUrl: string, width: number) => `${baseUrl}?width=${width}`;
